import React, { useEffect, useState } from 'react';
import { fetchAnnouncements } from '../../lib/announcementService';
import { Calendar, Megaphone } from 'lucide-react';
import NavigationHeader from '../homepage/components/NavigationHeader';

import FooterSection from "../homepage/components/FooterSection";

const AnnouncementsPage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      const data = await fetchAnnouncements();
      setAnnouncements(data);
      setLoading(false);
    };
    loadData();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pt-24 pb-12 px-4 sm:px-6 lg:px-8">
      <NavigationHeader />
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white sm:text-4xl">
            Latest Announcements
          </h1>
          <p className="mt-4 text-lg text-gray-500 dark:text-gray-400">
            Updates, news, and alerts from the PPSRNP team.
          </p>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        ) : (
          <div className="space-y-6">
            {announcements.map((item) => (
              <div key={item.id} className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
                <div className="p-6">
                  <div className="flex items-center gap-3 text-sm text-blue-600 dark:text-blue-400 mb-3">
                    <Megaphone className="w-4 h-4" />
                    <span className="font-semibold uppercase tracking-wider text-xs">Notice</span>
                    <span className="text-gray-400">•</span>
                    <div className="flex items-center gap-1 text-gray-500 dark:text-gray-400">
                      <Calendar className="w-4 h-4" />
                      {new Date(item.createdAt).toLocaleDateString()}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                    {item.title}
                  </h3>
                  <div 
                    className="prose prose-blue dark:prose-invert max-w-none text-gray-600 dark:text-gray-300"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                </div>
              </div>
            ))}
            
            {announcements.length === 0 && (
              <div className="text-center text-gray-500 py-12">
                No active announcements at this time.
              </div>
            )}
          </div>
        )}
      </div>
       <FooterSection />
    </div>
  );
};

export default AnnouncementsPage;